<template>
  <div class="footprint">
    <div class="tips" id="tips"></div>
    <div class="header" v-if="loginTrue">
      <ul>
        <li
          v-for="(item, index) in tabList"
          :class="active == index ? 'active' : ''"
          :key="index"
          @click="tabVideoList(item, index)"
        >
          {{ item.name }}<span v-if="active == index"></span>
        </li>
      </ul>
    </div>
    <div class="mainList" v-if="loginTrue">
      <dl v-for="(item, ind) in videoList" @click="toVideo(item)" :key="ind">
        <dt>
          <img :src="item.imageUrl" alt="" />
        </dt>
        <dd>
          <p class="title">{{item.videoName}}</p>
          <!-- -{{item.title}} -->
          <p class="type">{{item.type}}</p>
          <p class="times">{{item.lastWatchTime}}</p>
        </dd>
      </dl>
    </div>
    <div class="pageTips" v-if="pageTips">
      暂无浏览记录
    </div>
    <div class="back" v-if="isAndroid && loginTrue" @click="backHome">返回</div>
    <Login v-if="loginTk" />
    <ChoiceCompany
      :choiceTk="choiceTk"
      :mobile="mobile"
      :companyList="companyList"
      v-if="choiceTk"
    />
  </div>
</template>
<script>
import serivce from "@/utils/ajax";
import Login from "./components/login.vue";
import ChoiceCompany from "./components/choiceCompany.vue";
export default {
  components: {
    Login,
    ChoiceCompany,
  },
  data() {
    return {
      active: 0,
      tabList: [],
      videoList: [],
      isAndroid: false,
      pageTips:false,

      loginTk: false,
      mobile: "",
      companyList: [],
      choiceTk: false,
      loginTrue:true
    };
  },
  created(){
    if(this.$route.query.app_secret){
      sessionStorage.setItem("app_secret", this.$route.query.app_secret)
      localStorage.setItem("userInfo", this.$route.query.userInfo)
    }
  },
  mounted() {
    document.title = this.$route.query.from;

    if(sessionStorage.getItem("loginTk") && sessionStorage.getItem("loginMsg")){
      this.loginTk = sessionStorage.getItem("loginTk")
    }
    if (
      !localStorage.getItem("IntegratedTitle") ||
      !localStorage.getItem("userInfo")
    ) {
      localStorage.setItem("IntegratedTitle", this.$route.query.from);
      this.loginTk = true;
      this.loginTrue = false
    } else {
      this.loginTrue = true
      this.getList();
    }
    var u = navigator.userAgent,
      app = navigator.appVersion;
    this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
    if(this.$route.query.app_secret){
      this.isAndroid = false
      this.getList()
    }
  },
  methods: {
    tabCompany(companyList, phone) {
      this.mobile = phone;
      this.companyList = companyList;
      this.choiceTk = true;
    },
    backHome() {
      this.$router.push({
        path: "/IntegratedMy?title=" + this.$route.query.from,
      });
    },
    toVideo(e) {
      console.log(e);
      let params = {
        phone: JSON.parse(localStorage.getItem("userInfo")).phone,
        companyId: JSON.parse(localStorage.getItem("userInfo")).companyId,
        videoId: e.videoId,
      };
      serivce.post(`/sp_api/video/videoWatchBefore`, params).then((res) => {
        if (res.code == 0) {
          console.log(res);
        } else {
          this.pupUp(res.msg);
        }
      });
      if (e.jumpType == "url") {
        window.location.href = e.videoUrl;
      } else {
        const params = {
          playSrc: e.videoUrl,
          playName: e.name,
          playImg: e.imageUrl,
          from: this.$route.query.from
        };
        this.$router.push({ path: "/VideoView", query: params });
      }
    },
    getList() {
      this.loginTk = false
      this.choiceTk = false
      this.loginTrue = true
      let params = {
        phone: JSON.parse(localStorage.getItem("userInfo")).phone,
        companyId: JSON.parse(localStorage.getItem("userInfo")).companyId,
      };
      serivce.get(`/sp_api/video/findWatchHistoryList`, params).then((res) => {
        if (res.code == 0) {
          var brr = res.data.list;
          let title = ''
          
          if (brr.length > 0) {
            var arr = [];
            brr.forEach((item) => {
              item.videoList.forEach((i) => {
                arr.push(i);
              });
            });
            let obj = {
              name: "全部",
              sort: "全部",
              videoList: arr,
            };
            brr.unshift(obj);
            this.tabList = brr;
            if(localStorage.getItem("selName")){
              title = localStorage.getItem("selName")
              for (var i = 0; i < this.tabList.length; i++) {
                if (this.tabList[i].name == title) {
                  this.videoList = this.tabList[i].videoList;
                  this.active = i;
                }
              }
            }else{
              this.active = 0
              this.videoList = this.tabList[0].videoList;
            }
            
          }else{
            this.pageTips = true
          }
        } else {
          this.pupUp(res.msg);
        }
      });
    },
    getvideoprogress() {
      setTimeout(function () {
        var vid = document.getElementById("video");
        var currentTime = vid.currentTime.toFixed(1);
        if (currentTime == 1.2) {
          //触发
          return false;
        }
        console.log(currentTime);
        this.getvideoprogress();
      }, 50);
    },
    tabVideoList(list, index) {
      this.active = index;
      this.videoList = list.videoList;
      localStorage.setItem("selName", list.name);
      // const params = {
      //   type: this.$route.query.type,
      //   title: list.name,
      // };
      // this.$router.push({ path: "/videoList", query: params });
    },
  },
};
</script>
<style lang="less" scoped>
.header {
  width: 100%;
  height: 1.2rem;
  padding: 0.3rem;
  box-sizing: border-box;
  ul {
    min-width: 100%;
    display: flex;
    overflow-x: scroll;
    
    li {
      // flex: 1;
      padding: 0 0.3rem;
      font-size: 0.28rem;
      text-align: center;
      border: 1px solid #007bf6;
      border-right: 0;
      flex-shrink: 0;
      line-height: 0.6rem;
      color: #007bf6;
      position: relative;
    }
    li.active {
      color: #fff;
      background: #007bf6;
      font-size: 0.34rem;
      font-weight: bold;
    }
    li:first-child{
      border-radius: 0.1rem 0 0 0.1rem;
    }
    li:last-child{
      border-right: 1px solid #007bf6;
      border-radius: 0rem 0.1rem 0.1rem 0;
    }
  }
}
.mainList {
  display: flex;
  flex-wrap: wrap;
  padding: 0.5rem 0.3rem 1.2rem;
  dl {
    // width: 47.5%;
    margin-top: 0;
    margin-bottom: 0.3rem;
    width: 100%;
    display: flex;
    dt {
      flex-shrink: 0;
      img {
        width: auto;
        height: 1.5rem;
      }
    }
    dd {
      flex: 1;
      margin-left: 0.2rem;
      p{
        margin: 0;
      }
      p.title{
        font-size: 0.3rem;
        line-height: 0.4rem;
        // font-weight: bold;
        color: #333;
      }
      p.type{
        font-size: 0.24rem;
        color: #999;
      }
      p.times{
        font-size: 0.24rem;
        color: #999;
      }
    }
  }
}
.pageTips{
  font-size: 0.3rem;
  text-align: center;
}
.back {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 0.8rem;
  // padding: 0.2rem 0.3rem;
  background: #f7f7f7;
  line-height: 0.8rem;
  font-size: 0.32rem;
  // padding-left: 0.4rem;
  text-align: center;
}
</style>